module.exports = ".form-horizontal .control-label {\n    text-align: left !important;\n}\n\n.alert.alert-danger {\n    margin-bottom: 5px;\n}"